import { Component, OnInit } from '@angular/core';
@Component({
    selector: 'delivery-only-root',
    templateUrl: './delivery-only.component.html',
    styleUrls: ['./delivery-only.component.scss'],
    standalone: false
})
export class DeliveryOnlyComponent implements OnInit {
    constructor(
    ) { }

    ngOnInit(): void {

    }
}